import { render } from "./FamilyMember.vue?vue&type=template&id=3d315023"
import script from "./FamilyMember.vue?vue&type=script&lang=js"
export * from "./FamilyMember.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./FamilyMember.vue?vue&type=style&index=0&id=3d315023&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__